import React, { useEffect } from 'react'
import { listenerCustomEvent } from '../../classes/eventController'
import { useAlert } from '../../hooks/useState'

window.dataLayer = window.dataLayer || [];

const Alert = () => {
  const { setAlert, dataAlert, closeAlert } = useAlert(state => state)

  useEffect(() => {
    listenerCustomEvent("renderAlert", (event: CustomEvent) => {
      setAlert(event.detail)
      let timeAnimation = event.detail.time || 5000;
      document.documentElement.style.setProperty('--time', `${timeAnimation / 2}ms`);
      setTimeout(() => {
        document.querySelector('.ar__alert')?.classList.remove('anims-scale-up')
        document.querySelector('.ar__alert')?.classList.add('anims-scale-down')
        setTimeout(closeAlert, 300)
      }, timeAnimation)
    })


    /** example open alert
     *  
        window.openAlert({ 
          title: 'Hola', 
          desc: 'Mundo', 
          time: 5000, 
          type: 'great', 
          href: '/estadio-aguila/ranking'
        }) 
    */

    window.openAlert = ({ title, desc, type, time, href }) => {
      setAlert({ title, desc, type, time, href })
      const timeAnimation = time || 5000;
      document.documentElement.style.setProperty('--time', `${timeAnimation / 2}ms`);

      setTimeout(() => {
        document.querySelector('.ar__alert')?.classList.remove('anims-scale-up')
        document.querySelector('.ar__alert')?.classList.add('anims-scale-down')
        setTimeout(closeAlert, 300)
      }, timeAnimation)

    }

  }, [])

  const sendDatalayerAlert = (value: string) => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${value}`,
      'interaction': 'true',
      'component_name': 'User Zone',
      'element_text': `${value}`,
    });
  }

  if (!dataAlert) return <div className='alertEmpty'></div>

  return (
    <a className={`ar__alert glow is-close anims-scale-up ${dataAlert.type || 'great'}`} href={dataAlert.href && `${dataAlert.href}`} onClick={() => sendDatalayerAlert(`${dataAlert.title}`)}>
      <div id='ar__alert'>
        <h3 className='black_24'>{dataAlert.title}</h3>
        <p className='medium_24'>{dataAlert.desc}</p>
        <div className="alertLoader">
          <div className="alertLoader__body"></div>
        </div>
      </div>
    </a>
  )
}

export default Alert
